const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

/* CHARMAYS Personalizer — dynamic helper copy */
(() => {
  function syncCharmaysPersonalizerCopy() {
    document.querySelectorAll('.cp-root').forEach((root) => {
      const inputs = Array.from(root.querySelectorAll('.cp-input'));
      const help = root.querySelector('.cp-help');
      if (!help || !inputs.length) return;

      const limits = inputs
        .map((input) => parseInt(input.getAttribute('maxlength') || '0', 10))
        .filter((value) => Number.isFinite(value) && value > 0);
      const maxChars = limits.length ? Math.max(...limits) : null;

      if (inputs.length === 1) {
        const label = (inputs[0].dataset.label || '').trim();
        if (/prénom.*mot.*date/i.test(label)) {
          help.textContent = `Saisissez un prénom, un mot ou une date courte.${maxChars ? ` ${maxChars} caractères maximum.` : ''}`;
        } else {
          help.textContent = `Saisissez votre personnalisation.${maxChars ? ` ${maxChars} caractères maximum.` : ''}`;
        }
      } else {
        help.textContent = `Ajoutez jusqu’à ${inputs.length} lignes.${maxChars ? ` ${maxChars} caractères maximum par ligne.` : ''}`;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCharmaysPersonalizerCopy);
  } else {
    syncCharmaysPersonalizerCopy();
  }

  document.addEventListener('shopify:section:load', syncCharmaysPersonalizerCopy);
})();
